<template>
  <!-- 登录模块 -->
  <div class="login-wrapper">

    <div class="login-box" @keydown="handleKeyDown">
      <!-- 头像 -->
      <div class="login-avatar">
        <!-- <img src="@/assets/logo.png" alt /> -->
        <img class="avt" src="../images/mengzhengfile.png" alt />
        <!-- <img src="@/assets/log2.png" alt /> -->
      </div>
      <!-- 登录表单 -->
      <el-form
        class="login-form"
        ref="loginFormRef"
        :model="adminLoginForm"
        :rules="adminLoginFormRules"
      >
        <h3 class="userlogin">用户登录</h3>
        <!-- 用户名 -->
        <el-form-item prop="username">
          <el-input
            v-model="adminLoginForm.username"
            placeholder="请输入账号"
            @input="removeSpacesusername"
            maxlength="11"
            prefix-icon="iconfont iconicon"
          ></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input
            v-model="adminLoginForm.password"
            placeholder="请输入密码"
            @input="removeSpacespassword"
            prefix-icon="iconfont iconmima"
            type="password"
            show-password
          ></el-input>
        </el-form-item>

        <!-- 按钮 -->
        <el-form-item class="button">
          <el-button type="primary" @click="login">登录</el-button>
          <el-button type="success" @click="resetLoginForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>


    <div id="stars"></div>
    <div id="stars2"></div>
    <div id="stars3"></div>
    <div id="stars4"></div>

  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from '../utils/loading';

import './style.css'

export default {
  name: "Admin",
  data() {
    return {
      // 类型选择，默认选择管理员登录
      radio: "1",
      // 登录表单的对象
      adminLoginForm: {
        username: "",
        password: "",
      },
      adminLoginFormRules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            min: 3,
            max: 12,
            message: "长度在 5 到 12 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "密码长度在 6 到 15 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  // computed: {
  //   filteredMenus() {
  //     return this.jur.filter(item => item.jurType === "menu");
  //   }
  // },
  mounted() {

    document.addEventListener('keydown', this.handleKeyDown);


    this.handleTime();
    this.handleAllrequest();


    let username = localStorage.getItem("username");
    let password = localStorage.getItem("password");
    if( username && password){
        this.adminLoginForm.username = username
        this.adminLoginForm.password = password
    }

  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);

  },


  methods: {

    removeSpacesusername(event){
      this.adminLoginForm.username = event.replace(/\s+/g, '');

    },

    removeSpacespassword(event){
      
      this.adminLoginForm.password = event.replace(/\s+/g, '');

    },

    //   // 重置方法
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields();
    },
    //   getType() {
    //     // 调用这个方法直接获取到了类型
    //   },

    handleKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        this.login()
      }
    },

    getRegionIds (token) {
      axios.get(`${apiBaseUrl}/deptOrTea/getRegionIds`,
        { headers:{'authorization': token}}).then(res => {
          let cityTepy = res.data.data;
          window.localStorage.setItem('cityTepy', cityTepy);
          
      }).catch(error => { })
        
    },

    login() {
      
      this.$refs.loginFormRef.validate((valid) => {
        // 表单预验证/deptOrTea/getRegionIds 
        if (!valid) return;
        if (this.radio == 1) {
          loadingUtils.startLoading()
          // 登录
          this.$axios
            .post(`${apiBaseUrl}/admin/logintext`, {
              username: this.adminLoginForm.username,
              password: this.adminLoginForm.password,
            })
            .then((res) => {
              if (res.data.code == 200) {
                let ret = res.data.data;

                localStorage.setItem("username", this.adminLoginForm.username);
                localStorage.setItem("password", this.adminLoginForm.password);
                // 获取用户名和密码
                // 
                //把token保存到本地
                sessionStorage.setItem("tokenInfo", res.data.data.list.authorization);
                // this.$store.dispatch("getTokenInfo",res.data.data.list.authorization)
                window.localStorage.setItem("admin", JSON.stringify(ret.list));
                
                // 
                window.localStorage.setItem("jur", JSON.stringify(ret.list.jur));

                this.getRegionIds(ret.list.authorization)

                if(ret.list.jur[0].children[0].jurUrl){
                  if(ret.list.jur[0].children[0].jurUrl === '/classtasklist'){
                    this.$router.push(ret.list.jur[0].children[0].jurUrl);
                  }else{
                    this.$router.push("/classtasklist");
                  }
                  // 
                   if(ret.list.jur[0].jurTitle === '小程序权限'){
                      this.$router.push(ret.list.jur[1].children[0].jurUrl);      
                   }else{
                      // this.$router.push(ret.list.jur[0].children[0].jurUrl);
                      this.$router.push("/classtasklist");

                   }
                }else{
                   this.$router.push("/classtasklist");
                }

                let token = ret.token;
                //调用vuex的commit方法，将token保存到vuex中，来触发一个名为 "LOGIN_IN" 的 mutation
                this.$store.commit("LOGIN_IN", token);
                this.$message({
                  message: "登录成功",
                  type: "success",
                  duration: 1000,
                });
              } else {
                // alert(res.data.message);
                this.$message.error(res.data.message);
                this.adminLoginForm.password = "";
              }
            })
            .catch((error) => {
              this.$message.error("登录失败");
            })
            .finally(() => {
              setTimeout(() => {
                loadingUtils.endLoading()
              },500)
            });
        }
      });
    },
    formatConvert(date) {
      let myyear = date.getFullYear();
      let mymonth = date.getMonth() + 1;
      let myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },
    handleTime() {
      const now = new Date(); // 获取当前日期
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1); // 获取当前月的第一天
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 获取当前月的下个月的第零天，即当前月的最后一天

      // this.startTime1 = this.formatConvert(new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate() - 7))
      // this.endTime1 = this.formatConvert(new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate() + 11))
      this.startTime1 = this.formatConvert(
        new Date(
          firstDay.getFullYear(),
          firstDay.getMonth(),
          firstDay.getDate()
        )
      );
      this.endTime1 = this.formatConvert(
        new Date(
          lastDay.getFullYear(),
          lastDay.getMonth(),
          lastDay.getDate()
        )
      );
      sessionStorage.setItem("TIME_START", this.startTime1)
      sessionStorage.setItem("TIME_END", this.endTime1)
    },
    handleAllrequest() {
      axios.get(`${apiBaseUrl}/schedule/teacherlist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        let { data } = res;
        if (data.code == 200) {
          sessionStorage.setItem("teacherlist_Jons", JSON.stringify(data.data));
        }
      });
      axios.get(`${apiBaseUrl}/schedule/categorylist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        let { data } = res;
        if (data.code == 200) {
          sessionStorage.setItem("categorylist_Jons", JSON.stringify(data.data));
        }
      });

      axios
        .post(`${apiBaseUrl}/schedule/selectschedule`, {
          teacher_id: "",
          page: "",
          limit: "",
          start_time: this.startTime1,
          end_time: this.endTime1,
          student_id: "",
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          let { data } = res;
          if (data.code == 200) {
            sessionStorage.setItem("selectschedule_Jons", JSON.stringify(data.data));
          }
        });
      //  规划学生 studentType：1
      axios.post(`${apiBaseUrl}/student/getStudentList`,{
        studentType:1
      },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        let { data } = res;
        if (data.code == 200) {
          sessionStorage.setItem("getStudentList_Jons", JSON.stringify(data.data));
        }
      });
      // 线下学生 studentType：2
      axios.post(`${apiBaseUrl}/student/getStudentList`,{
        studentType:2
      },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        let { data } = res;
        if (data.code == 200) {
          sessionStorage.setItem("getStudentList_Jons_s", JSON.stringify(data.data));
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin-bottom: 50px;
}

.login-type {
  display: flex;
  justify-content: left;
}

.button {
  display: flex;
  margin-top: 15px;
  justify-content: center;
}

.login-wrapper {
  // background:  #428BCA;
  background: #5a93b5;
  height: 100%;
}
.login-avatar {
  height: 130px;
  width: 130px;
  border: 1px solid #eee;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 49%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  img {
    height: 100%;
    width: 100%;
    border-radius: 50%;
    background-color: #eee;
  }
}

.title {
  color: #fff;
}

.userlogin {
  text-align: center;
  margin-right: 8px;
}

.login-box {
  width: 550px;
  height: 380px;
  background-color: #fff;
  border-radius: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
@media screen and (max-width: 750px) {
  .login-avatar {
    width: 90px;
    height: 90px;
  }
  .login-box {
    width: 380px;
    height: 350px;
  }
}

@keyframes rotateCircle {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.avt {
  animation: rotateCircle 5s linear infinite;
}

</style>



// WEBPACK FOOTER //
// src/pages/Admin.vue